import { BackButton, FilteredCreditApplication } from '@applyonline/shared'

import UploadFilesTable from '../../../../components/UploadFilesTable'

interface Props {
  creditApp: FilteredCreditApplication
}

const DocumentsPage = ({ creditApp }: Props) => {
  return (
    <main className="general-message">
      <UploadFilesTable creditApp={creditApp} />
      <BackButton />
    </main>
  )
}

export default DocumentsPage
